import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { FlowServiceService } from "src/app/Services/flow-service.service";

@Component({
  selector: "app-report-review-dialog",
  templateUrl: "./report-review-dialog.component.html",
  styleUrls: ["./report-review-dialog.component.scss"],
})
export class ReportReviewDialogComponent implements OnInit {
  message: string = "";
  otherMessage: string = "";
  reason: string = "";
  reasonsToSubmit: string[] = [];
  selectedRadio: string = "";
  showTextArea: boolean = false;

  userData: any;

  constructor(
    private flowServiceService: FlowServiceService,
    private toastr: ToastrService,
    public dialogRef: MatDialogRef<ReportReviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { review: any; flowData: any }
  ) {
    this.reasonsToSubmit = [];
  }

  ngOnInit(): void {
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
  }

  onRadioChange(value: string) {
    this.selectedRadio = value;
  }

  onReasonChange(selectedReason: string): void {
    this.reason = selectedReason;
    if (selectedReason === "copycat" || selectedReason === "other") {
      this.showTextArea = true;
    } else {
      this.showTextArea = false;
    }
  }

  submit(): void {
    this.reasonsToSubmit = [];

    if (this.reason === "sexual") {
      this.reasonsToSubmit.push("Sexual content");
    } else if (this.reason === "graphic") {
      this.reasonsToSubmit.push("Graphic violence");
    } else if (this.reason === "hateful") {
      this.reasonsToSubmit.push("Hateful or abusive content");
    } else if (this.reason === "rating") {
      this.reasonsToSubmit.push("Improper content rating");
    } else if (this.reason === "illegal") {
      this.reasonsToSubmit.push("Illegal prescription or other drug");
    } else if (this.reason === "copycat") {
      this.reasonsToSubmit.push("Copycat or impersonation");
    } else if (this.reason === "other") {
      this.reasonsToSubmit.push("Other objection");
    }

    if (!this.reason) {
      this.toastr.warning("Please select a reason");
      return;
    }

    if (!this.userData) {
      this.toastr.error("Please login to report this review");
      return;
    }

    const flowTitle =
      this.data?.flowData?.title ||
      this.data?.flowData?.flowTitle ||
      "Review on flow";

    const flowModel = {
      ReportedByUserEmail: this.userData.emailAddress,
      ContentId: this.data?.flowData?.rowKey || null,
      ContentTitle: flowTitle,
      ContentType: "Review",
      Reasons: this.reasonsToSubmit[0],
      Message: this.message,
      OtherMessage: this.otherMessage,
      FlowRowKey: this.data?.flowData?.rowKey || null,
      ReviewRowKey: this.data.review.rowKey,
    };

    this.flowServiceService.reportFlow(flowModel).subscribe(
      (response) => {
        this.toastr.success("Review reported successfully");
        this.dialogRef.close(true);
      },
      (error) => {
        console.error("Error reporting review", error);
        this.toastr.error("Failed to report review. Please try again.");
      }
    );
  }

  close(): void {
    this.dialogRef.close();
  }
}


